// extracted by mini-css-extract-plugin
module.exports = {"list":"EditProductPage_list__1kLES","listContainer":"EditProductPage_listContainer__2yIz3"};